import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function Partners() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/partners`)
      .then((r) => setPartners(r.data))
      .catch(() => {});
  }, []);

  if (partners.length === 0) return null;

  const row = [...partners, ...partners];

  return (
    <section
      data-testid="partners-band"
      className="relative overflow-hidden border-y border-white/10 bg-[#0D0D0F] py-8"
    >
      <div className="mx-auto mb-6 max-w-7xl px-6 lg:px-10">
        <p className="font-tac text-[10px] tracking-[0.4em] text-[#F5B301]">
          KOOPERATIONSPARTNER
        </p>
      </div>
      <div className="relative overflow-hidden">
        <div className="marquee-track flex w-max items-center">
          {[0, 1].map((half) => (
            <div key={half} className="flex items-center" aria-hidden={half === 1}>
              {row.map((p, i) => {
                const inner = (
                  <span className="flex items-center gap-4">
                    <img
                      src={`${BACKEND}/api/partner-image/${p.logo_path}`}
                      alt={p.name}
                      title={p.description || p.name}
                      className="h-12 w-auto max-w-[180px] object-contain opacity-60 grayscale transition duration-300 group-hover:opacity-100 group-hover:grayscale-0 lg:h-14"
                    />
                    <span className="font-tac text-xs uppercase tracking-[0.2em] text-white/40 transition-colors duration-300 group-hover:text-white/80">
                      {p.name}
                    </span>
                  </span>
                );
                const cls =
                  "group flex items-center px-10 py-2";
                return p.website ? (
                  <a
                    key={`${half}-${i}`}
                    href={p.website.startsWith("http") ? p.website : `https://${p.website}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={half === 0 ? `partner-link-${p.id}` : undefined}
                    className={cls}
                  >
                    {inner}
                  </a>
                ) : (
                  <div
                    key={`${half}-${i}`}
                    data-testid={half === 0 ? `partner-item-${p.id}` : undefined}
                    className={cls}
                  >
                    {inner}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
